import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import ProjectsFilter from "../../../projects/client/ProjectsFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import MaterialPagination from "../../../styles/materialPagination";
import ProjectList from "./ProjectsList";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import { removeTransferFromCollection } from "../../../../utils/collections";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

const ProjectsContainer = ({ match }) => {
  const [projects, setProjects] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "project",false,true),
    "name": checkFilterItem(history, "name", null)

  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchProjects = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/projects" + filterUrl + "&user.id=" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setProjects(removeTransferFromCollection(response.data["hydra:member"]));
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchProjects();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="content-head">
        <ProjectsFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <ProjectList projects={projects} />
      {totalPageCount > 1  &&
      <MaterialPagination
        count={totalPageCount}
        shape="rounded"
        page={filterData.page}
        onChange={(event, page) => onChangePage(event, page)}
      />}
    </>
  );
};

export default ProjectsContainer;
